// src/components/brands/BrandTable.js
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { useCarContext } from '../components/Context/CarContext';
import ConfirmDialog from '../views/ConfirmDialog';
import EditDialogEngineClass from './EditDialog/EditDialogEngineClass';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
const EngineTable = () => {

    const { DeleteEngineClass, engine, editEngine, editOpen, setEditOpen, editType,UpdateEngineClass, currentEditData } = useCarContext();
  const [open, setOpen] = useState(false);
  const [selectedEngineId, setSelectedEngineId] = useState(null);
  const handleDeleteClick = (id) => {
    setSelectedEngineId(id); // Set the brand ID to delete
    setOpen(true); // Open the confirmation dialog
  };

  const handleClose = () => {
    setOpen(false); // Close the confirmation dialog
    setSelectedEngineId(null); // Clear the selected brand ID
  };

  const handleConfirm = () => {
    if (selectedEngineId) {
      DeleteEngineClass(selectedEngineId); // Delete the selected brand
    }
    setOpen(false); // Close the confirmation dialog
  };

    // Handle Save from Edit Dialog
    const handleSaveEditEngineClass = (updatedData) => {

        /* setUpdated(updatedData)*/
        UpdateEngineClass(updatedData)



    };

    const columns = [
      { 
        field: 'link', 
        headerName: 'Link', 
        width: 50, 
        renderCell: (params) => ( 
        <i className="bi bi-info-circle"></i> 
        ), 
      },
      { 
        field: 'name', 
        headerName: 'Engine Class',
         width: 150, 
      },
      { 
        field: 'oilQuantity', 
        headerName: 'Oil Quantity',
         width: 150, 
      },
      { 
        field: 'action', 
        headerName: 'Action', 
        width: 150, 
        renderCell: (params) => ( 
        <div> 
          <IconButton color="primary" onClick={() => editEngine(params.row)} > 
            <Edit /> 
          </IconButton> 
          <IconButton color="secondary" onClick={() => handleDeleteClick(params.row.id)} > 
            <Delete /> 
          </IconButton> 
        </div> ), 
      },

      
     ]; 
     const CustomToolbar = () => ( 
      <GridToolbarContainer> 
        <GridToolbar /> 
      </GridToolbarContainer> 
      );
 function EditToolbar(props) {
     const { setRows, setRowModesModel } = props;
 }

  console.log(engine)
  return (
    <section className="section">
    <div className="row">
      <div className="col-lg-12">
            <div className="card">
                <div className="card-body">
                  <h5 className="card-title"></h5>
                    {/* Tabs */}
                    <Box sx={{ width: '100%' }}>
                        <AppBar position="static" color="default">
                            {/* AppBar content can go here */}
                        </AppBar>
                    </Box>
                    <div style={{ height: '100%', width: '100%' }}>
                        <DataGrid
                         rows={engine}
                         columns={columns}
                         slots={{ toolbar: CustomToolbar }}
                         components={{ Toolbar: GridToolbar }}
                      />
                        <ConfirmDialog
                         open={open}
                         onClose={handleClose}
                         onConfirm={handleConfirm}
                         title="Confirm Deletion"
                         content="Are you sure you want to delete this brand?"
                      />
                  {/* EditDialogBrand for Editing */}
                  <EditDialogEngineClass
              open={editOpen}
               handleClose={() => setEditOpen(false)}
               type={editType}
               currentData={currentEditData}

               handleSave={handleSaveEditEngineClass}
           />
                    </div>
                </div>
            </div>
        </div></div>
</section>
    
        // <TableContainer component={Paper}>
        //   <Table aria-label="engines table">
        //     <TableHead>
        //       <TableRow>
        //         <TableCell><strong>Engine Class</strong></TableCell>
        //         <TableCell><strong>Oil Quantity</strong></TableCell>
        //         <TableCell align="right"><strong>Actions</strong></TableCell>
        //       </TableRow>
        //     </TableHead>
        //     <TableBody>
        //       {engine.length === 0 ? (
        //         <TableRow>
        //           <TableCell colSpan={3} align="center">
        //             <Typography variant="body1">No Engine Class available.</Typography>
        //           </TableCell>
        //         </TableRow>
        //       ) : (
        //         engine.map((engineItem) => (
        //           <TableRow key={engineItem.id}>
        //             <TableCell>{engineItem.name}</TableCell>
        //             <TableCell>{engineItem.oilQuantity}</TableCell>
        //             <TableCell align="right">
        //               <IconButton
        //                 color="primary"
        //                 onClick={() => editEngine(engineItem)}
        //               >
        //                 <Edit />
        //               </IconButton>
        //               <IconButton
        //                 color="secondary"
        //                 onClick={() => handleDeleteClick(engineItem.id)}
        //               >
        //                 <Delete />
        //               </IconButton>
        //             </TableCell>
        //           </TableRow>
        //         ))
        //       )}
        //     </TableBody>
        //   </Table>
          
        //   <ConfirmDialog
        //     open={open}
        //     onClose={handleClose}
        //     onConfirm={handleConfirm}
        //     title="Confirm Deletion"
        //     content="Are you sure you want to delete this Engine Class?"
        //   />
        //   <EditDialogEngineClass
        //       open={editOpen}
        //       handleClose={() => setEditOpen(false)}
        //       type={editType}
        //       currentData={currentEditData}

        //       handleSave={handleSaveEditEngineClass}
        //   />
        // </TableContainer>
      
      );
    };

export default EngineTable;
